import { render, staticRenderFns } from "./ModelDetaiPage.vue?vue&type=template&id=3ed6aaa6&scoped=true"
import script from "./ModelDetaiPage.vue?vue&type=script&lang=js"
export * from "./ModelDetaiPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/modelDetailPage.scss?vue&type=style&index=0&id=3ed6aaa6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed6aaa6",
  null
  
)

export default component.exports